import { useEffect, useState } from 'react';
import * as ApplicationApi from 'api/applicationApi';
import BottomSheetDialog from 'components/BottomSheetDialog';
import HintText from 'components/HintText';
import Image from 'components/Image';
import CompanyBusinessInfo from 'components.special/CompanyBusinessInfo';
import RestaurantOperatingHours from 'components.special/RestaurantOperatingHours';
import { RefundPolicyText } from 'data/refundPolicyText';
import withSettings from 'hocs/withSettings';
import * as ComponentUtils from 'utils/component';
import * as SessionStorage from 'utils/sessionStorage';
import * as Toast from 'utils/toast';
import * as ErrorMessage from 'utils/errorMessage';

let cachedCompanyProfile = null;

const AboutDialog = ({ closeDialog, settings }) => {
    const [companyProfile, setCompanyProfile] = useState(cachedCompanyProfile);
    const [showRefundPolicy, setShowRefundPolicy] = useState(false);
    const { viewLogo } = settings;

    useEffect(() => {
        if (companyProfile) return;

        const qrCode = SessionStorage.getQRCode();

        ApplicationApi.getCompanyProfileData(qrCode)
            .then((result) => {
                cachedCompanyProfile = result;
                setCompanyProfile(result);
            })
            .catch((error) => Toast.showErrorMessage(ErrorMessage.fetchError(error)));
    }, [companyProfile]);

    return (
        <>
            <BottomSheetDialog title="About" isOpen closeDialog={closeDialog}>
                <div className="d-flex flex-column p-3">
                    <div className="d-flex flex-column align-items-center py-1">
                        <Image
                            className="border rounded-circle"
                            style={{ objectFit: 'contain' }}
                            width="80px"
                            height="80px"
                            imageSrc={viewLogo ? viewLogo : '/img/home-default-restaurant-logo.png'}
                        />

                        {companyProfile && (
                            <div className="d-flex flex-column align-items-center mt-3">
                                <span className="fw-bold fs-3">{companyProfile.companyName}</span>
                                {companyProfile.registerNo && (
                                    <HintText className="mt-1">{companyProfile.registerNo}</HintText>
                                )}
                            </div>
                        )}
                    </div>

                    <span className="fw-bold mb-2 mt-2">Opening Hours</span>
                    <div className="apps-component-about-dialog-card">
                        <RestaurantOperatingHours />
                    </div>

                    <span className="fw-bold mb-2 mt-4">Contact Us</span>
                    {companyProfile ? (
                        <div className="apps-component-about-dialog-card">
                            <CompanyBusinessInfo companyProfile={companyProfile} />
                        </div>
                    ) : (
                        <span className="fs-5" style={{ color: 'var(--grey-500)' }}>Loading...</span>
                    )}

                    <div className="text-center text-decoration-underline fs-6 mt-3">
                        <span className="text-muted" role="button" onClick={() => setShowRefundPolicy(true)}>
                            Refund Policy
                        </span>
                    </div>

                    <div className="d-flex align-items-center justify-content-center mt-5">
                        <Image className="me-3" imageSrc="/img/qr-ordering-logo-2.png" width="130px" />

                        <HintText>{`v${window.APP_SETTINGS_Version}`}</HintText>
                    </div>
                </div>
            </BottomSheetDialog>

            <BottomSheetDialog isOpen={showRefundPolicy} title="Refund Policy" fullScreen closeDialog={() => setShowRefundPolicy(false)}>
                <p className="p-3" style={{ textAlign: 'justify' }}>{companyProfile?.refundPolicy ?? RefundPolicyText}</p>
            </BottomSheetDialog>
        </>
    );
};

const hocs = [withSettings];

export default ComponentUtils.compose(hocs)(AboutDialog);
